import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { provideHooks } from 'redial';
import data from 'desktop/containers/reloadData';
import { Redirect } from 'react-router-dom';
import * as commonAction from './actionCreators/common';
import * as categoryAction from './actionCreators/category';
import Category from 'desktop/containers/Category/Loadable';
import Product from 'desktop/containers/Product/Loadable';
import BlankWidget from './desktop/components/CategoryListing/Widgets/BlankWidgets';
import SidebarBlank from './desktop/components/Common/SidebarBlank';
import LeftBlankContent from './desktop/components/Common/LeftBlankContent';
import Cms from 'desktop/containers/CmsMapping/Loadable';
import NotFound from 'desktop/containers/NotFound/Loadable';
import { readQueryParam } from './utils/helper';

@provideHooks({
  fetch: ({ location, store: { dispatch, getState } }) => {
    // pass pathname without '/' from starting or ending to redis key
    let path = location.pathname.slice(1).replace(/(\/+)$/g, '');
    let categoryId = null;
    // path = path.split('#')[0];
    const pageCounter = Number(readQueryParam('page', `${location.search}`, __SERVER__)) || 0;
    path = path.split('#')[0];
    // LKUI-1305
    if (path === 'contact-lenses.html') {
      path = 'cms-contacts';
    }
    // redis call to get cat/pdp url
    const temp = {};
    temp.location = location;
    temp.counter = 1;
    temp.location.hash = '';
    temp.FilterDataObj = {};
    temp.reset = true;
    temp.isFilterEnable = false;
    temp.section = location.state ? location.state.section : 'BlankLoader';
    temp.categoryScrollTo = 0;
    temp.reload = {};
    temp.categoryData = {};
    temp.reload.data = {};
    temp.reload.reload = false;
    temp.order = 'best_sellers';
    dispatch(categoryAction.modifyData(temp));
    dispatch(commonAction.modifyData({ appLogo: '', redisLoaded: false }));
    const state = getState();
    if (__CLIENT__) {
      let params = window.location.hash ? window.location.hash : null;
      const pathname = window.location.pathname;
      const catData = state.category.dataCategoryList[path] || null;
      let productId = null;
      let cmsId = null;
      let section = '';
      if (location.state) {
        categoryId = location.state.categoryId;
        productId = location.state.productId;
        cmsId = location.state.cmsId;
        section = location.state.section;
      } else if (pathname === '/search') {
        section = 'cat';
      }
      if (catData && !window.location.hash && pathname !== '/search') {
        dispatch(commonAction.changeSection('cat'));
        window.scrollBy(0, 1);
        dispatch(categoryAction.showCachedCategoryData(catData));
        dispatch(commonAction.modifyData({ categoryID: catData.catData.result.categoryId, redisLoaded: true, redisLoading: false }));
      } else {
        dispatch(commonAction.changeSection(section));
        params = data.reloadData(window.location.hash.replace('#', ''), categoryAction, location);
        dispatch(commonAction.getRedisRouter({ path, params, categoryId, productId, cmsId, section, location, pageCounter }));
      }
    }
    if (__SERVER__) {
      const params = location.hash ? location.hash : null;
      let section = '';
      if (location.pathname === '/search') {
        section = 'cat';
        dispatch(commonAction.changeSection(section));
      }
      dispatch(commonAction.getRedisRouter({ path, params, section, categoryId, location, pageCounter }));
    }
    if (state.common.section === '' || state.common.section === 'na') {
      dispatch(commonAction.changeLogo('lenskart'));
    }
  }
})

class RedisMapping extends Component {
  static propTypes = {
    section: PropTypes.string,
    categoryID: PropTypes.any,
    productID: PropTypes.string,
    categoryData: PropTypes.object,
    productData: PropTypes.object,
    commonAction: PropTypes.object.isRequired,
    cmsData: PropTypes.string,
    redisCommonData: PropTypes.object,
    isCollectionData: PropTypes.bool,
    redisLoading: PropTypes.bool,
    redisLoaded: PropTypes.bool
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    if (this.props.categoryData && this.props.categoryData.result) {
      this.props.commonAction.changeSection('cat', true);
    } else if (this.props.productData && this.props.productData.result) {
      this.props.commonAction.changeSection('prod', true);
    } else if (this.props.cmsData) {
      this.props.commonAction.changeSection('cms', true);
    } else if (this.props.location.pathname === '/search') {
      this.props.commonAction.changeSection('cat', true);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.section !== this.props.section) window.scrollTo(0, 0);
  }

  setWishList = (pId, shortListData) => {
    const { commonAction } = this.props;
    let flag;
    if (shortListData && shortListData.result.productList) {
      flag = shortListData.result.productList.some(shortListProduct => {
        if (pId === shortListProduct.id) {
          return true;
        }
        return false;
      });
    }
    if (flag) {
      commonAction.shortlist(null, 'delete', `/${pId}`);
    } else {
      commonAction.shortlist(pId, 'post', '');
    }
  };

  _convertHttps(value) {
    if (value) {
      return value.replace('http:', 'https:');
    }
  }

  renderLoader(section) {
    if (!section || section === 'BlankLoader') {
      return (<div className="text-center loding-product-count" style={{ marginTop: '30px' }}>
        <img alt="loader" src="//static.lenskart.com/skin/frontend/base/default/images/ajaxscroll/loader.gif" />
        <div>Loading more products, please be patient...</div>
      </div>);
    }
    return '';
  }

  render() {
    const { section, redisLoading, redisLoaded, productID, redisCommonData, commonAction, categoryAction, isCollectionData, cmsData, location, productData } = this.props;
    return (
      section === 'cat' && location.pathname.indexOf('/mobile') === 0
        ? <Redirect to={{ pathname: location.pathname.replace('/mobile', '') }}></Redirect>
        : <div>
          {this.renderLoader(section)}
          {
            section === 'cat' && <div>
              {
                <div>
                  {redisLoading &&
                    (location.pathname === '/contact-lenses.html' ?
                      (<div className="text-center loding-product-count" style={{ marginTop: '30px' }}>
                        <img alt="loader" src="//static.lenskart.com/skin/frontend/base/default/images/ajaxscroll/loader.gif" />
                        <div>Loading data, please be patient...</div>
                      </div>) :
                      (<div className="redis-loader">
                        <div className="filters-navigate default-filters">
                          <BlankWidget styleObj="filter-loader" />
                        </div>
                        <BlankWidget styleObj="category-loader" />
                      </div>)
                    )
                  }
                  {/** page counter only meant for first load of page as it wont refresh value on page scroll */}
                  {redisLoaded && <Category {...this.props} setWishList={this.setWishList} pageCounter={Number(readQueryParam('page', `${location.search}`, true)) || 0} />}
                </div>
              }
            </div>
          }
          {
            section === 'prod' &&
            <div>
              {
                redisLoading && <div>
                  <LeftBlankContent />
                  <SidebarBlank />
                </div>
              }
              {
                redisLoaded && productData && <Product {...this.props} productData={this.props.productData} productID={productID} redisCommonData={redisCommonData} setWishList={this.setWishList} commonAction={commonAction} categoryAction={categoryAction} />
              }
            </div>
          }
          {section === 'cms' && <Cms isCollectionData={isCollectionData} cmsData={cmsData} location={location} commonAction={commonAction} redisCommonData={redisCommonData} />}
          {section === 'col' && <Cms {...this.props} />}
          {section === 'na' && <NotFound {...this.props} />}
        </div>
    );
  }
}

const mapStateToProps = state => ({
  section: state.common.section,
  categoryID: state.common.categoryID,
  productID: state.common.productID,
  categoryData: state.category.categoryData,
  productData: state.product.productData,
  modifiedProductData: state.product.modifiedProductData,
  redisCommonData: state.common.redisCommonData,
  cmsData: state.cmsMapping.cmsData,
  location: state.router.location,
  isCollectionData: state.cmsMapping.isCollectionData,
  isSupported: state.common.isSupported,
  checkBrowser: state.common.checkBrowser,
  redisLoaded: state.common.redisLoaded,
  redisLoading: state.common.redisLoading
});

function mapDispatchToProps(dispatch) {
  return {
    commonAction: bindActionCreators(commonAction, dispatch),
    categoryAction: bindActionCreators(categoryAction, dispatch)
  };
}

RedisMapping.defaultProps = {
  redisCommonData: {}
};

export default connect(mapStateToProps, mapDispatchToProps)(RedisMapping);
